import React from 'react';

interface AppStoreButtonProps {
  className?: string;
  variant?: 'dark' | 'white' | 'mini';
}

export const AppStoreButton: React.FC<AppStoreButtonProps> = ({ className = '', variant = 'dark' }) => {
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    alert('AppStatsView is coming soon to the App Store. Join the waitlist or explore the web intelligence platform!');
  };

  if (variant === 'mini') {
    return (
      <button
        type="button"
        onClick={handleClick}
        className={`inline-flex items-center gap-2 bg-[#0b0d11] hover:bg-[#1a202c] text-white px-3.5 py-2 rounded-xl text-xs font-semibold shadow-md transition-all ${className}`}
        aria-label="Download on the App Store"
      >
        <svg className="w-4 h-4 fill-current" viewBox="0 0 24 24" aria-hidden="true">
          <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.34-.07 2.27.74 3.05.8 1.16-.24 2.27-.93 3.51-.84 1.48.12 2.6.7 3.34 1.76-3.05 1.83-2.33 5.85.47 6.98-.56 1.48-1.29 2.95-2.37 4.28ZM12.03 7.25C11.88 5.05 13.67 3.24 15.72 3c.29 2.54-2.3 4.43-3.69 4.25Z" />
        </svg>
        <span>Download</span>
      </button>
    );
  }

  const isWhite = variant === 'white';

  return (
    <button
      type="button"
      onClick={handleClick}
      className={`inline-flex items-center gap-3 px-4 py-2.5 rounded-2xl min-w-[195px] text-left transition-all duration-200 hover:-translate-y-0.5 shadow-lg ${
        isWhite
          ? 'bg-white hover:bg-slate-50 text-[#0a1020] shadow-slate-200/50'
          : 'bg-[#080a0f] hover:bg-[#141923] text-white shadow-black/20'
      } ${className}`}
    >
      <svg className="w-7 h-7 fill-current flex-shrink-0" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.34-.07 2.27.74 3.05.8 1.16-.24 2.27-.93 3.51-.84 1.48.12 2.6.7 3.34 1.76-3.05 1.83-2.33 5.85.47 6.98-.56 1.48-1.29 2.95-2.37 4.28ZM12.03 7.25C11.88 5.05 13.67 3.24 15.72 3c.29 2.54-2.3 4.43-3.69 4.25Z" />
      </svg>
      <span className="leading-tight">
        <small className="block text-[10px] tracking-wide opacity-80 uppercase font-medium">Download on the</small>
        <strong className="block text-[17px] font-bold tracking-tight">App Store</strong>
      </span>
    </button>
  );
};
